import { Quote } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/site/Reveal";

export default function Testimonials({ testimonials }) {
  return (
    <section id="stories" data-testid="testimonials-section" className="border-y border-white/5 bg-[#0A0A0A]">
      <div className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
        <SectionHeading kicker="Royal Voices" title="Stories From Our Winners" testid="testimonials-heading" align="center" />
        <div className="grid gap-10 md:grid-cols-3">
          {testimonials.map((t, i) => (
            <Reveal key={t.id || i} delay={i * 0.12}>
              <blockquote
                data-testid={`testimonial-card-${i}`}
                className="flex h-full flex-col border-l-2 border-[#D4AF37]/50 pl-8"
              >
                <Quote className="h-7 w-7 text-[#D4AF37]/60" strokeWidth={1} />
                <p className="font-display mt-6 flex-1 text-xl font-light italic leading-relaxed text-neutral-200">
                  “{t.quote}”
                </p>
                <footer className="mt-8">
                  <div data-testid={`testimonial-name-${i}`} className="text-sm tracking-wide text-[#D4AF37]">
                    {t.name}
                  </div>
                  <div className="mt-1 text-[11px] uppercase tracking-[0.25em] text-neutral-500">{t.role}</div>
                </footer>
              </blockquote>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
